<template>

  <div class="hatch-container" v-bind:class="customClasses">

    <!-- background left -->
    <div class="svg-background-left">
      <hatch-bg></hatch-bg>
    </div>

    <!-- background right -->
    <div class="svg-background-right">
      <hatch-bg></hatch-bg>
    </div>

  </div>
  
</template>

<script>
  import hatch_bg from '../svg/hatch_bg'
  export default {
    props: ['full'],
    components: {
      'hatch-bg': hatch_bg
    },
    computed: {
      customClasses () {
        if (!!this.full) {
          return 'hatch-full'
        }
      }
    }

  }
</script>

<style scoped lang='scss'>

  @import '../../styles/variables';

  .hatch-container {
    position: absolute;
    top: 0;
    left: 0;
    margin-top: -1px;
    width: calc(100% - 72px);
    height: calc(100% + 1px);
    pointer-events: none;
    // background-color: $white;
    overflow: hidden; // SVGs overflow container
    &.hatch-full {
      width: 100%;
    }
    @media screen and (max-width: $md-max) , screen and (max-height: $md-height-max) {
      width: 100%;
      transform: none;
    }

  }

  .svg-background-left, .svg-background-right {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    svg {
      position: absolute;
      top: 0;
      margin-top: 1px;  
      width: auto;
      height: 100%;
    }
  }

  .svg-background-left {
    @media screen and (max-width: $sm-max) {
      transform: scaleX(0.65) translateX(-27.5%) !important;
    }
    svg {
      left: 0;
      margin-left: 0px;
      transform: translateX(-1px);
    }
  }

  .svg-background-right {
    @media screen and (max-width: $sm-max) {
      transform: scaleX(0.65) translateX(27%) !important;
    }
    svg {
      right: 0;
      transform: scale(-1, 1) translateX(-1px);

    }
  }

</style>


// WEBPACK FOOTER //
// span_background.vue?2574ca9a